/** What a Next Best Action (or one of its "ways") asks the user to do (CT-5713). */
export const NBA_ACTION_TYPES = Object.freeze({
  REVIEW_DRAFT: 'review_draft',
  REVIEW_WORKFLOW: 'review_workflow',
  VIEW_DETAILS: 'view_details',
  HAND_TO_CONCIERGE: 'hand_to_concierge',
});

/**
 * Dispatch by action TYPE, never by tag text: the types that open the Next Best
 * Action slide-out, and in which mode…
 */
export const NBA_PANEL_MODE_BY_ACTION = Object.freeze({
  [NBA_ACTION_TYPES.REVIEW_WORKFLOW]: 'journey',
  [NBA_ACTION_TYPES.VIEW_DETAILS]: 'details',
});

/** …and the types that go to the Concierge, with the intent they carry (CT-5721). */
export const NBA_CONCIERGE_INTENT_BY_ACTION = Object.freeze({
  [NBA_ACTION_TYPES.REVIEW_DRAFT]: 'review_draft',
  [NBA_ACTION_TYPES.HAND_TO_CONCIERGE]: 'hand_to_concierge',
});

/** The `Chip` variant of each tag key; an unknown key reads as neutral. */
export const NBA_TAG_VARIANTS = Object.freeze({
  draft_ready: 'success',
  email: 'informative',
  workflow: 'purple',
  buying_intent: 'warning',
  reviewer: 'warning',
});
